export const sanitizeListColumns = (columns, defaultSort, sortBy) => {
  if (sortBy.length > 0) {
    sortBy.forEach((sortItem) => {
      const column = columns.find((column) => column.name === sortItem.name)
      if (column) {
        column.sort = sortItem.direction
      }
    })
  } else {
    defaultSort.forEach((sortItem) => {
      const column = columns.find((column) => column.name === sortItem.name)
      if (column) {
        column.sort = sortItem.direction
      }
    })
  }

  return columns
}
